import { tampleteImagesEditRoute } from '@features/enterprise/api/constants';
import { errorMessage, Timezone } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateList } from '../constants';

type useEditTemplateImagesProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

type EditTemplateVariables = {
  template_id?: number;
  etemplate_id?: number;
  name?: string;
  description?: string;
  status?: number;
  company_id?: number;
  alert_message_email?: 0 | 1;
  alert_application_email?: 0 | 1;
  alert_reference_email?: 0 | 1;
  s_phone?: string;
  s_name?: string;
  email?: string;
  s_address1?: string;
  s_website_url?: string;
  our_hiring_culture?: string;
  color1?: string;
  color2?: string;
  default_declined_message?: string;
  default_saved_message?: string;
  default_interview_message?: string;
  default_open_interview_message?: string;
  default_hire_message?: string;
  default_declined_post_interview_message?: string;
  default_saved_post_interview_message?: string;
  default_request_more_info_message?: string;
  default_archive_message?: string;
  unresponsive_message?: string;
  unresponsive_interview?: string;
  keep_declined_applications?: boolean;
  keep_unattended_applications?: boolean;
  timezone?: Timezone;
  cover_image: string | null;
  blur_opacity?: number;
  additional_images?: string[] | null | undefined;
  secondary_color?: string | null;
  background_blur?: string | null;
  additional_text?: string | null;
  job_page_heading?: string | null;
};

export const useEditTemplateImages = ({
  setErrorText = () => {},
}: useEditTemplateImagesProps) => {
  const client = useQueryClient();

  const { mutate: editTemplateImages, isLoading: isUpdatingTemplateImages } =
    useMutation({
      mutationFn: (variables: EditTemplateVariables) =>
        axiosInstance
          .post(tampleteImagesEditRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([templateList]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    editTemplateImages,
    isUpdatingTemplateImages,
  };
};
